import { Button } from "../button/Button.js";
import "../button/index.js";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
//#region src/anchor-button/AnchorButton.tsx
const AnchorButton = ({ disabled, variant, color, size, shape, className, children, ref, ...rest }) => {
	const buttonProps = {
		variant,
		color,
		size,
		shape,
		ref
	};
	if (disabled) {
		const validInteractions = {
			onFocus: rest.onFocus,
			onBlur: rest.onBlur,
			onPointerEnter: rest.onPointerEnter,
			onPointerLeave: rest.onPointerLeave,
			onPointerMove: rest.onPointerMove,
			onMouseEnter: rest.onMouseEnter,
			onMouseLeave: rest.onMouseLeave,
			onMouseMove: rest.onMouseMove
		};
		return /* @__PURE__ */ jsx(Button, {
			disabled: true,
			className,
			"aria-label": rest["aria-label"],
			...buttonProps,
			...validInteractions,
			children
		});
	}
	return /* @__PURE__ */ jsx(Button, {
		asChild: true,
		className: twMerge("inline-flex", className),
		...buttonProps,
		children: /* @__PURE__ */ jsx("a", {
			...rest,
			children
		})
	});
};
//#endregion
export { AnchorButton };
